import React from 'react';
import { useTranslation } from 'react-i18next';

import PersonContentTable from '../../../components/sections/PersonContent/PersonContentTable/PersonContentTable';

const FindUsAtSection = ({ contacts = {}, brandColors = {} }) => {
  const { t } = useTranslation();
  return (
    <>
      {(contacts.location ||
        contacts.name ||
        contacts.email ||
        contacts.phone) && (
        <PersonContentTable header={t('event.organisation.find-us-at-event')}>
          <div className="c-person-content-section__container">
            <ul className="c-person-content-section__contacts">
              {contacts.location && (
                <li
                  className="c-person-content-section__contacts-item"
                  data-test-find-us="stand-li"
                >
                  <strong>{t('event.organisation.stand-number')}</strong>
                </li>
              )}
              {contacts.location && (
                <li
                  className="c-person-content-section__contacts-item"
                  data-test-find-us="location-li"
                >
                  {contacts.location}
                </li>
              )}
              {(contacts.name || contacts.email || contacts.phone) && (
                <li
                  className="c-person-content-section__contacts-item"
                  data-test-find-us="meeting-li"
                >
                  <strong>{t('event.organisation.setup-meeting')}</strong>
                </li>
              )}
              {contacts.name && (
                <li
                  className="c-person-content-section__contacts-item"
                  data-test-find-us="name-li"
                >
                  {contacts.name}
                </li>
              )}
              {contacts.email && (
                <li className="c-person-content-section__contacts-item">
                  <a
                    href={`mailto:${contacts.email}`}
                    style={{ color: '#' + brandColors.secondary }}
                    data-test-find-us="email-a"
                  >
                    {contacts.email}
                  </a>
                </li>
              )}
              {contacts.phone && (
                <li className="c-person-content-section__contacts-item">
                  <a
                    href={`tel:${contacts.phone}`}
                    style={{ color: '#' + brandColors.secondary }}
                    data-test-find-us="phone-a"
                  >
                    {contacts.phone}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </PersonContentTable>
      )}
    </>
  );
};

export default FindUsAtSection;
